import { useEffect, useState } from "react";
import { Button } from "../components/ui/button";
import { Download } from "lucide-react";

export function InstallButton() {
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => setPrompt(null);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!prompt) return null;

  const install = async () => {
    prompt.prompt();
    try {
      await prompt.userChoice;
    } finally {
      setPrompt(null);
    }
  };

  return (
    <Button
      data-testid="pwa-install-btn"
      onClick={install}
      size="sm"
      className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold uppercase text-xs tracking-wide"
    >
      <Download className="w-4 h-4 sm:mr-2" />
      <span className="hidden sm:inline">Installa</span>
    </Button>
  );
}
